import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M4 20V9h4v11Zm6 0V4h4v16Zm6 0v-7h4v7Z" />,
  'BarChart',
)
